<template>
  <SuggestPart
      item-value="id"
      item-text="title"
      itemsKey="tariffs"
      :fetchData="fetchData"
      v-bind="$attrs"
      v-on="$listeners"
  >
    <template
        v-slot:action="{
          init
        }"
    >
      <template
          v-if="createButton"
      >
        <Create
            :small="true"
            @onCreate="init"
        />

        &nbsp;
      </template>
    </template>
  </SuggestPart>
</template>

<script>
  import Tariffs from '@/services/tariffs'

  import SuggestPart from '@/components/_Part/Suggest'

  import Create from '@/components/Tariffs/Create'

  export default {
    name: 'Suggest',
    props: [
      'createButton'
    ],
    components: {
      SuggestPart,
      Create
    },
    methods: {
      fetchData() {
        return Tariffs
          .suggest()
      }
    }
  }
</script>
